import { Roles } from 'src/shared/enums';
import { AuthGuard } from '../shared/auth/guards/auth.guard';
import { RoleGuard } from '../shared/auth/guards/role.guard';

export const jobsPaths = {
	default: '',
	root: 'jobs',
	list: 'list',
	detail: ':id',
	calendar: 'calendar',
	apiRequestList: 'flairdocsRequestList',
	assignments: ':id/assignments',
};

export const jobsFragments = {
	default: [jobsPaths.default],
	root: [jobsPaths.default, jobsPaths.root],
	calendar: [jobsPaths.default, jobsPaths.root, jobsPaths.calendar],
	list: [jobsPaths.default, jobsPaths.root, jobsPaths.list],
	apiRequestList: [
		jobsPaths.default,
		jobsPaths.root,
		jobsPaths.apiRequestList,
	],
	assignments: (id: number) => [
		jobsPaths.default,
		jobsPaths.root,
		id,
		'assignments',
	],
	detail: (id: number) => [jobsPaths.default, jobsPaths.root, id],
};

export const jobsDefaultAuthRoles = [
	Roles.Admin,
	Roles.FieldDirector,
	Roles.FieldManager,
	Roles.FieldSupport,
	Roles.HR,
];

export const jobsDefaultAuth = {
	canActivate: [AuthGuard, RoleGuard],
	data: { roles: jobsDefaultAuthRoles },
};
